import {createApp, VueElement} from 'vue';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import App from './App.vue';
import $storage from './storage.js'
import pkg from '../package.json';

const app = createApp(App);
app.config.globalProperties.$app_version = pkg.version;
app.config.globalProperties.$app_name = pkg.name + '_' + pkg.version;
app.config.globalProperties.$storage = $storage;
app.mount('#app'); 
